<div class="header">
  <span class="title">Simulação - Resultado Parcial</span>
  <button *ngIf="showProductsButton" class="btn btn-full-orange" (click)="abrirModalProdutos()">
    Produtos Omni
    <span class="fa fa-gear"></span>
  </button>
</div>

<div class="simulator">
  <div class="blue-title">
    <div class="info-panel">
      <div class="info">
        <span class="text">VALOR SOLICITADO</span>
        <span class="value">{{ proposta.valorLiquido | currency: 'BRL' }}</span>
      </div>
      <div class="vertical-line"></div>
      <div class="info">
        <span class="text">Prazo para <br />1º pagamento </span>
        <span class="value">{{ proposta.tabela.carencia }} dias</span>
      </div>
    </div>
  </div>

  <div class="middle-buttons">
    <button class="btn btn-border-orange" (click)="abrirModalAlterarValor()">
      Alterar valor
    </button>
    <button class="btn btn-border-orange" (click)="abrirModalPrimeiroPgto()">
      Alterar prazo do 1º pagamento
    </button>
  </div>

  <div class="white-selector">
    <div class="selector-title">
      <span> Opções de parcelamento </span>
    </div>
    <div class="button-row" #buttonRow>
      <button
        class="btn btn-full-orange"
        *ngFor="let opcao of opcoesParcelamento; let i = index"
        [ngClass]="{ focus: index === i }"
        [id]="opcao.period + 'x'"
        [value]="opcao.period + 'x'"
        (click)="onSelect(i)"
      >
        <div class="info">
          <span
            ><b>{{ opcao.period }}x</b></span
          >
          <span>{{ opcao.amount | currency: 'BRL' }}</span>
          <span>
            {{
              opcao.interest > 0
                ? 'juros ' + opcao.interest + '% a.m.'
                : 'sem juros'
            }}</span
          >
        </div>
      </button>
    </div>

    <div *ngIf="simulacao">
      <div class="selector-title">
        <span>DATA DA PRIMEIRA PARCELA</span>
      </div>
      <div class="selector-date">
        <span>{{ simulacao.firstPaymentDate | date: 'dd/MM/yyyy' }}</span>
      </div>
      <div class="change-date-btn" >
        <button class="btn btn-border-orange">
          <calendar
            [titleCalendar]="'Data da primeira parcela'"
            [startDate]="simulacao.gracePeriodRange.from"
            [endDate]="simulacao.gracePeriodRange.to"
            [dateSelected]="calendarFirstPaymentDate"
            (dateSelectedChange)="onChangePrimeiroPagamento($event)"
            subtitleCalendar="Selecione a melhor data para o cliente realizar o pagamento da primeira parcela."
          >
            Alterar data
            <i class="fa fa-pencil"></i>
          </calendar>
        </button>
      </div>
    </div>
  </div>
</div>

<app-botao-navegacao
  (previous)="onClickPrevious()"
  (next)="onClickNext()"
  [previousShow]="true"
  [nextShow]="true"
  nextLabel="Continuar"
  previousLabel="Salvar e continuar depois"
  buttonIcon="fa-save"
></app-botao-navegacao>

<app-loader-circles *ngIf="showLoader"></app-loader-circles>
